import React, { Component } from 'react';
import './header.css';

class Header extends Component {
  render() {
    return (
		<header className="main-header">
			<div className="in">
				<h1><a href="#/"><svg id="header-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
    <g id="header-logo-small-group" transform="translate(0.000000, 84.000000)">
        <rect id="header-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
        <rect id="header-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
    </g>
</svg> Politiche 2018</a><span>{( (this.props.Title) ? " / " + this.props.Title : "" )}</span></h1>
				<a href="#/nav" id="nav-toggle" onClick={ (e) => { e.preventDefault(); this.props.ToggleNav(); } }><div className="in"><div className="top"></div><div className="bottom"></div><div className="middle"></div></div></a>
			</div>
		</header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Elezioni/header.js